"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InfoCircleLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/InfoCircleLine.svg"));
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _defineType = require("../_util/defineType");
var _checkbox = _interopRequireDefault(require("../checkbox"));
var _helpInfo = _interopRequireDefault(require("../help-info"));
var _icon = _interopRequireDefault(require("../icon"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
const TypographyTitle = props => {
  const {
    type = 'inherit',
    size = '20-24',
    checkbox,
    info,
    help,
    extra,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-typography-title");
  const childrenElement = (0, _ahooks.useCreation)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames.default)('content', "size-".concat(size), "type-".concat(type)),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: children
    }), !(0, _defineType.isNone)(info) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
      title: info,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        type: "suggest/InfoCircleLine",
        className: "icon-tooltip"
      })
    }), !!help && /*#__PURE__*/(0, _jsxRuntime.jsx)(_helpInfo.default, {
      ...help,
      className: "icon-tooltip"
    })]
  }), [size, type, children, info, help]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...restProps,
    className: (0, _classnames.default)(baseClassName, className),
    style: style,
    children: [checkbox ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.default, {
      shape: "circular",
      ...checkbox,
      style: {
        display: 'flex',
        ...checkbox.style
      },
      children: childrenElement
    }) : childrenElement, !(0, _defineType.isNone)(extra) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "extra",
      children: extra
    })]
  });
};
var _default = exports.default = TypographyTitle;